const routes = {
  '/app/expert-invite': {
    fetch: () =>
      import(
        /* webpackChunkName: 'expert-invite-route' */ 'app/expert-invite/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
